// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.b-header__job-search-field[data-v-c43c73fa] {\n  width: 150px;\n  margin: auto;\n  margin-right: 5px;\n  padding: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
